export { default } from "./OrderStatusSkeleton.jsx";
